import { categoryDetailSubCategoriesStyles } from "@insite/content-library/Widgets/Category/CategoryDetailSubCategories";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

categoryDetailSubCategoriesStyles.container = {
    ...categoryDetailSubCategoriesStyles.container,
    offsetCss: css`
        margin: 0px !important;
        /* justify-content: space-between; */
        max-width: 100%;
        column-gap: 10px;
    `,
};
categoryDetailSubCategoriesStyles.innerContainer = {
    ...categoryDetailSubCategoriesStyles.innerContainer,
    css: css`
        height: 100%;
    `,
    offsetCss: css`
        padding: 1rem;
        max-width: 100%;
        height: 100%;
    `,
};
categoryDetailSubCategoriesStyles.subCategoryItem = {
    ...categoryDetailSubCategoriesStyles.subCategoryItem,
    // width: [6, 6, 4, 4, 4],
    css: css`
        border: 1px solid ${getColor("common.border")};
        box-shadow: 0px 0px 14px rgba(0, 0, 0, 0.07);
        border-radius: 4px;
        position: relative;
        margin-bottom: 1rem !important;
        &:hover::after {
            transform: scaleY(1);
            transition: transform 0.125s ease-in-out;
        }
        &::after {
            background-color: ${getColor("primary")};
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
            content: "";
            height: 0.5rem;
            position: absolute;
            top: 0;
            transform: scaleY(0);
            transform-origin: top center;
            width: 100%;
        }
        ${({ theme }) => {
            return breakpointMediaQueries(
                theme,
                [
                    css`
                        max-width: 100%;
                        flex-basis: 100%;
                    `,
                    css`
                        max-width: 49%;
                        flex-basis: 49%;
                    `,
                    css`
                        max-width: 49%;
                        flex-basis: 49%;
                    `,
                    css`
                        max-width: 32%;
                        flex-basis: 32%;
                    `,
                    null,
                ],
                "min",
            );
        }}
    `,
};

categoryDetailSubCategoriesStyles.subCategoryImageItem = {
    ...categoryDetailSubCategoriesStyles.subCategoryImageItem,
    width: 12,
    css: css`
        width: 100%;
        padding: 0;
    `,
};

categoryDetailSubCategoriesStyles.subCategoryNameLinkItem = {
    ...categoryDetailSubCategoriesStyles.subCategoryNameLinkItem,
    width: 12,
    css: css`
        width: 100%;
        margin-top: 1rem !important;
        align-items: end;
    `,
};

categoryDetailSubCategoriesStyles.subCategoryImageClickable = {
    ...categoryDetailSubCategoriesStyles.subCategoryImageClickable,
    css: css`
        width: 100%;
        display: flex;
        justify-content: center;
    `,
};

categoryDetailSubCategoriesStyles.subCategoryNameLink = {
    ...categoryDetailSubCategoriesStyles.subCategoryImageClickable,
    css: css`
        width: 100%;
    `,
    color: "primary",
    typographyProps: {
        css: css`
            width: 100%;
            text-align: center;
            word-wrap: break-word;
            font-family: "Roboto-Bold";
        `,
    },
};

categoryDetailSubCategoriesStyles.subCategoryImage = {
    ...categoryDetailSubCategoriesStyles.subCategoryImage,
    css: css`
        position: relative;
        display: inline-flex;
        align-items: initial;
        flex-direction: initial;
        overflow: hidden;
        justify-content: center;
        width: 100%;
        height: 130px;
        max-width: 200px;
    `,
};
